import { type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SettingsSectionCard } from "@/features/seller-portal/SettingsSectionCard";
import { SELLER_PORTAL_NS } from "@/features/seller-portal/i18n";
import type { MyShopProfile } from "@/features/seller-portal/api";

export function AccountSecuritySection({
  profile,
}: {
  profile: MyShopProfile;
}): ReactElement {
  const { t } = useTranslation(SELLER_PORTAL_NS);
  return (
    <SettingsSectionCard
      title={t("settings.sections.account")}
      testid="settings-section-account"
    >
      <div className="flex flex-col gap-1 text-sm">
        <span className="text-[var(--g-ink-2)]">
          {t("settings.account.phone")}:{" "}
          <span className="text-foreground">{profile.seller.phone_e164}</span>
        </span>
      </div>
      {/* SCRUM-176: "login & security" points at Active sessions (device
          list + revoke + "log out everywhere else") — the actual security
          surface for this shared identity (ADR-035/043: admin/seller are
          RBAC-derived personas on ONE account row, so there's no separate
          seller-specific security page to build; /account/profile is just
          name/region editing and doesn't deliver on this CTA's promise). */}
      <Link
        to="/account/sessions"
        data-testid="account-manage-link"
        className="text-sm font-semibold text-[var(--g-primary-ink)]"
      >
        {t("settings.account.manage")} →
      </Link>
    </SettingsSectionCard>
  );
}
